import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { SensiboDevice } from 'clipsal-cortex-types/src/api/api-sensibo-devices';

import { selectSite } from '../../site/siteSlice';
import { useGetSensiboDevicesQuery } from './sensiboApi';

export function useHasSensiboDeviceFault() {
  const { site_id: siteID, integrations } = useSelector(selectSite);
  const { data } = useGetSensiboDevicesQuery(siteID, {
    skip: !integrations.sensibo,
  });

  return useMemo(
    () => !!data?.some((device: SensiboDevice) => !['NORMAL', null].includes(device.operating_state)),
    [data]
  );
}
